module.exports = __webpack_public_path__ + "static/create-modern-d1290d9105ec4048181fe18bda91d787.png";